import React from "react";
import SimpleModalContent from "./SimpleModalContent";

interface ModalDownloadType {
	title: string;
	onSuccess: (projectName: string) => void;
	options?: {
		submitText?: string;
	};
}

export default function ModalDownloadContent(props: ModalDownloadType) {
	const [projectName, setProjectName] = React.useState("");
	const options = {submitText: "Download", ...props.options};
	const inputRef = React.useRef<HTMLInputElement>(null);

	React.useEffect(() => {
		inputRef.current?.focus();
	}, []);

	return (
		<SimpleModalContent
			title={props.title}
			onSuccess={() => props.onSuccess(projectName)}
			options={options}
		>
			<div>
				<label htmlFor="projectName">Project Name:</label>
				<input
					ref={inputRef}
					id="projectName"
					type="text"
					value={projectName}
					onChange={(e) => setProjectName(e.target.value)}
					style={{marginLeft: "10px"}}
				/>
			</div>
			<p>
				Note: If you leave this blank, the current project name will be used.
			</p>
		</SimpleModalContent>
	);
}
